module.exports = __webpack_public_path__ + "static/media/zoom-blue.bdd7fb55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/zoom-blue.svg
// module id = 276
// module chunks = 3